import React from 'react';
import { IonImg, IonSpinner, IonText } from '@ionic/react';
import { SupportedPublicLocale } from '../types';
import appLogoLight from '../../../assets/images/app-logo-light.png';
import appLogoDark from '../../../assets/images/app-logo-dark.png';

interface PublicReportLoadingProps {
  locale: SupportedPublicLocale;
}

const translations = {
  en: {
    loading: 'Loading cleaning record...',
  },
  fr: {
    loading: 'Chargement du registre de nettoyage...',
  },
};

const PublicReportLoading: React.FC<PublicReportLoadingProps> = ({ locale }) => {
  const t = translations[locale];
  const isDarkMode = document.body.classList.contains('dark');

  return (
    <div className="ion-padding d-flex flex-direction-column h-100 justify-center">
      {/* Logo */}
      <div className="ion-text-center ion-padding-vertical">
        <IonImg
          src={isDarkMode ? appLogoDark : appLogoLight}
          alt="Otuvy Frontline"
          className="margin-auto"
          style={{ height: '48px', width: 'auto' }}
        />
      </div>

      {/* Loading Spinner */}
      <div className="ion-text-center ion-padding-vertical">
        <IonSpinner name="crescent" color="primary" style={{ width: '48px', height: '48px' }} />
        <IonText color="medium">
          <p className="font-16 ion-margin-top">{t.loading}</p>
        </IonText>
      </div>
    </div>
  );
};

export default PublicReportLoading;
